import { LinkTo } from '@ember/routing';
import Tile from '../tile';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { t } from 'ember-intl';

<template>
  <LinkTo @route="authenticated.repaying-student-debt.coaching">
    <Tile @headerText={{t "dashboard_tiles.student_loan_coaches"}}>
      <:description>
        {{t "dashboard_tiles.schedule_expert_call"}}
      </:description>
      <:image>
        {{svgJar
          "woman-on-laptop-working"
          width="100%"
          height="100%"
          role="img"
          desc=(t "svg.woman_on_laptop_working")
        }}
      </:image>
    </Tile>
  </LinkTo>
</template>
